import { render, staticRenderFns } from "./SearchImot.vue?vue&type=template&id=5472e6c8"
import script from "./SearchImot.vue?vue&type=script&lang=js"
export * from "./SearchImot.vue?vue&type=script&lang=js"
import style0 from "./SearchImot.vue?vue&type=style&index=0&id=5472e6c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports